import script from "./TeamsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamsList.vue?vue&type=script&setup=true&lang=ts"

import "./TeamsList.vue?vue&type=style&index=0&id=ccf515d0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccf515d0"]])

export default __exports__